import { render, staticRenderFns } from "./apaas.vue?vue&type=template&id=0d5481ac&"
import script from "./apaas.vue?vue&type=script&lang=js&"
export * from "./apaas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports